'use client';

import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../..';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import styles from './HRVfactorModal.module.css';
// import { useWindowSize } from 'hooks/dom/useWindowSize';

export const HRVfactorModal = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  const { width } = useWindowSize();
  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      role="button"
      tabIndex={0}
      aria-labelledby="hrv-factor-modal-heading"
    >
      <div className="container">
        <h4 id="hrv-factor-modal-heading">
          {t('ring.bentoRecoverySection.hrvCard.modal.head')}
        </h4>
        <h3>{t('ring.bentoRecoverySection.hrvCard.modal.subHead')}</h3>
        <div className="modal-items">
          <div className="item">
            <p className="text-mid">
              {t('ring.bentoRecoverySection.hrvCard.modal.cardA.descA')}{' '}
              <span className="bold">
                {t('ring.bentoRecoverySection.hrvCard.modal.cardA.descBold')}
              </span>{' '}
              {t('ring.bentoRecoverySection.hrvCard.modal.cardA.descB')}
              <br />
              <br />
              {t('ring.bentoRecoverySection.hrvCard.modal.cardA.descC')}
            </p>
            <div
              className="img-container"
              role="img"
              aria-label={t(
                'hRVfactorModal.content.ariaLabel.hrvFactorVisualization',
              )}
            >
              {width > 992 ? (
                <Image
                  src={'web_v2/ring-buy/sleep/png/HRVFlipNew.png'}
                  fill
                  alt=""
                  className="hrv-flip-a"
                  aria-hidden="true"
                />
              ) : (
                <Image
                  src={'web_v2/ring-buy/recovery/svg/flip/hrvFlipAresp.svg'}
                  fill
                  alt=""
                  className="hrv-flip-a"
                  aria-hidden="true"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
